import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { ThemeContext } from '../../../App/ThemeContext';
import classes from './Separate.module.scss';

const Separate = (props) => {
  const { name } = props;
  const { theme } = useContext(ThemeContext);

  return (
    <div className={`${classes.Separate} ${theme ? classes[theme] : ''}`}>
      <div className={classes.title}>{ ReactHtmlParser(name) }</div>
    </div>
  );
};

export default React.memo(Separate);

Separate.propTypes = {
  name: PropTypes.string.isRequired,
};
